<template>
  <div class="stock_add_page">
    <b-breadcrumb :items="breadCrumbs" />
    <div class="row">
      <div class="col-6 offset-3">
        <div style="padding:15px;width:100%;">
          <div class="form-group">
            <label for="model">Model *</label>
            <input
              :class="{
                'is-invalid': $v.form.model.$invalid && submit,
                'is-valid': !$v.form.model.$invalid && submit
              }"
              type="text"
              ref="model"
              v-model="form.model"
              @change="trimExpiryDate"
              @keyup="trimExpiryDate"
              class="form-control"
              id="model"
              name="model"
              aria-describedby="model_help"
              placeholder="Model i.e:IM20-18"
            />
            <div class="invalid-feedback">Please provide a Model Number</div>
          </div>

          <div class="form-group">
            <label for="qty">Quantity *</label>
            <input
              :class="{
                'is-invalid': $v.form.qty.$invalid && submit,
                'is-valid': !$v.form.qty.$invalid && submit
              }"
              type="text"
              v-model="form.qty"
              class="form-control"
              id="qty"
              name="qty"
              aria-describedby="qty_help"
              placeholder="Quantity i.e:99"
            />
            <div class="invalid-feedback" v-if="!$v.form.qty.required">
              Please provide a Quantity
            </div>
            <div class="invalid-feedback" v-if="!$v.form.qty.numeric">
              Only numbers allowed
            </div>
          </div>

          <div v-if="attributes">
            <div class="form-group">
              <label for="name">Name *</label>
              <input
                :class="{
                  'is-invalid': $v.form.productName.$invalid && submit,
                  'is-valid': !$v.form.productName.$invalid && submit
                }"
                type="text"
                v-model="form.productName"
                class="form-control"
                id="name"
                name="name"
                aria-describedby="model_help"
                placeholder="Name i.e:Noopept"
              />
              <div class="invalid-feedback">Please provide a name</div>
            </div>

            <div class="form-group">
              <label for="ingredients">Ingredients *</label>
              <textarea
                rows="7"
                cols="50"
                :class="{
                  'is-invalid': $v.form.ingredients.$invalid && submit,
                  'is-valid': !$v.form.ingredients.$invalid && submit
                }"
                v-model="form.ingredients"
                class="form-control"
                id="ingredients"
                name="ingredients"
                aria-describedby="ingredients_help"
                placeholder="Ingredients i.e: pramiracetam, microcrystalline cellulose"
              ></textarea>
              <div class="invalid-feedback">Please provide ingredients</div>
            </div>

            <div class="form-group">
              <label for="stockable">stockable *</label>
              <select
                :class="{
                  'is-invalid': $v.form.stockable.$invalid && submit,
                  'is-valid': !$v.form.stockable.$invalid && submit
                }"
                v-model="form.stockable"
                class="form-control"
                id="stockable"
                name="stockable"
              >
                <option value="yes">yes</option>
                <option value="no">no</option>
              </select>
            </div>

            <div class="form-group">
              <label for="length">Length</label>
              <input
                :class="{
                  'is-invalid': $v.form.length.$invalid && submit,
                  'is-valid': !$v.form.length.$invalid && submit
                }"
                type="text"
                v-model="form.length"
                class="form-control"
                id="length"
                name="length"
                aria-describedby="model_help"
                placeholder="length in cm"
              />
              <div class="invalid-feedback">Please provide a length</div>
            </div>

            <div class="form-group">
              <label for="width">Width</label>
              <input
                :class="{
                  'is-invalid': $v.form.width.$invalid && submit,
                  'is-valid': !$v.form.width.$invalid && submit
                }"
                type="text"
                v-model="form.width"
                class="form-control"
                id="width"
                name="width"
                aria-describedby="model_help"
                placeholder="width in cm"
              />
              <div class="invalid-feedback">Please provide a width</div>
            </div>

            <div class="form-group">
              <label for="height">Height</label>
              <input
                :class="{
                  'is-invalid': $v.form.height.$invalid && submit,
                  'is-valid': !$v.form.height.$invalid && submit
                }"
                type="text"
                v-model="form.height"
                class="form-control"
                id="height"
                name="height"
                aria-describedby="model_help"
                placeholder="height in cm"
              />
              <div class="invalid-feedback">Please provide a height</div>
            </div>
            <div class="form-group">
              <label for="weight">Weight</label>
              <input
                :class="{
                  'is-invalid': $v.form.weight.$invalid && submit,
                  'is-valid': !$v.form.weight.$invalid && submit
                }"
                type="text"
                v-model="form.weight"
                class="form-control"
                id="weight"
                name="weight"
                aria-describedby="model_help"
                placeholder="weight in grams"
              />
              <div class="invalid-feedback">Please provide a weight</div>
            </div>
          </div>

          <div class="d-flex flex-column align-items-end">
            <button
              style="width:150px;"
              class="btn btn-success mb-2"
              type="button"
              @click="stock('add')"
            >
              Add
            </button>
            <button
              style="width:150px;"
              class="btn btn-danger mb-2"
              type="button"
              @click="stock('reduce')"
            >
              Reduce
            </button>
          </div>
          <br />
          <br />
          <br />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, numeric, integer } from "vuelidate/lib/validators";
export default {
  name: "shopify-stock-add",
  components: {},
  data() {
    return {
      form: {
        model: "",
        qty: "",
        productName: "",
        length: "",
        width: "",
        height: "",
        weight: "",
        ingredients: "",
        stockable: "yes"
      },
      submit: false,
      attributes: false,
      breadCrumbs: [
        { text: "Dashboard", to: { name: "dashboard" } },
        { text: "Stock", to: { name: "stock" } },
        { text: "Add New Item", active: true }
      ]
    };
  },
  mounted() {
    this.$refs.model.focus();
  },
  validations() {
    if (!this.attributes) {
      return {
        form: {
          model: {
            required
          },
          qty: {
            required,
            numeric,
            integer
          }
        }
      };
    } else {
      return {
        form: {
          model: {
            required
          },
          qty: {
            required,
            numeric,
            integer
          },
          productName: {
            required
          },
          ingredients: {
            required
          },
          stockable: {
            required
          },
          length: {
            numeric,
            integer
          },
          width: {
            numeric,
            integer
          },
          height: {
            numeric,
            integer
          },
          weight: {
            numeric,
            integer
          }
        }
      };
    }
  },
  methods: {
    trimExpiryDate() {
      const model = this.form.model;
      var matches = model.match(/-[0-9]{6}/);
      if (matches) {
        this.form.model = model.split(matches[0])[0];
      }
    },
    stock(action) {
      this.submit = true;
      if (!this.$v.$invalid) {
        //show loader
        let loader = this.$loading.show();
        let formData = {
          model: this.form.model,
          action: action,
          qty: this.form.qty,
          name: this.form.productName,
          length: this.form.length,
          width: this.form.width,
          height: this.form.height,
          weight: this.form.weight,
          ingredients: this.form.ingredients,
          stockable: this.form.stockable
        };

        this.$http.post(this.APIURL + this.BRAND + "/stock", formData).then(
          response => {
            if (response.data.status == "new" && action == "add") {
              this.attributes = true;
              this.$swal(
                "New Product Detected!",
                "This Model doesn't exist in stock, if you want to add a new product please fill in the below details:!",
                "info"
              );
              this.submit = false;
              loader.hide();
            } else if (response.data.status == "failed" && action == "reduce") {
              this.$swal("Error!", response.data.error, "warning");
              this.submit = false;
              loader.hide();
            } else {
              this.$swal({
                title: "Success!",
                showConfirmButton: false,
                timer: 1000,
                html:
                  "Operation completed successfully, taking you back to product list.",
                type: "success",
                onClose: () => {
                  loader.hide();
                  this.$router.push({ name: "stock" });
                }
              });
            }
          },
          error => {
            console.log(error);
          }
        );
      }
    }
  }
};
</script>
